import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { AuthProvider } from "@/context/AuthContext";

// Silence the benign "ResizeObserver loop" warning that Radix/shadcn can emit,
// which otherwise triggers CRA's full-screen error overlay in development.
const swallowResizeObserverError = (e) => {
  if (e?.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener("error", swallowResizeObserverError);

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
